<template>
  <w-icon-wrapper
    :height='25'
    :width='16'
    icon-name='work-nav-collapse-icon'
    view-box='0 0 25 16'
  >
    <g
      id="_01_Einklappen_Icon"
      data-name="01_Einklappen_Icon"
      transform="translate(-3789 -5074)"
    >
      <path
        id="menu_open_24dp_FILL0_wght400_GRAD0_opsz24"
        d="M120-704v-2.667h17.333V-704Zm0-6.667v-2.667h13.333v2.667Zm0-6.667V-720h17.333v2.667Z"
        transform="translate(3669 5794)"
        fill="currentColor"
      />
      <path
        id="menu_open_24dp_FILL0_wght400_GRAD0_opsz24-2"
        data-name="menu_open_24dp_FILL0_wght400_GRAD0_opsz24"
        d="M142.133-705.333,135.467-712l6.667-6.667,1.538,1.538.328.328-4.8,4.8,4.8,4.8Z"
        transform="translate(3670 5794)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavCollapse' };
</script>